<template>
    <BorrarModalComponent
        :name="'borrarCupon-' + voucher.id"
        title="¿Seguro que quieres borrar este cupón?"
        borrarTitle="Datos del cupón"
        confirmButton="Borrar este cupón?"
        v-on:close="() => close(false)"
        v-on:confirm="() => deleteVoucher()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nombre:</b> {{ voucher.name }}
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>
    import BorrarModalComponent from "@/components/backend/components/BorrarModalComponent";

    export default {
        props: ['voucher'],
        computed: {
            lista() {
                return this.$store.getters.getListaId;
            }
        },
        methods: {
            close(borrado) {
                this.$emit('close', 'borrarCupon-' + this.voucher.id, borrado);
                this.$emit('actualizar');
            },
            deleteVoucher() {
                const params = {
                    lista_id: this.lista,
                    voucher_id: this.voucher.id,
                };

                this.$store.dispatch(this.config.getVuexAlias('back.lista.vouchers.delete'), params).then(res => {
                    this.$toast.success('cupón eliminado con éxito');
                    this.close(true);
                }).catch(error => {
                    this.$toast.error(error.response.data.message);
                })
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
